/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SchoolTypeSwitch.vue?vue&type=template&id=cdcbb71e&scoped=true"
import script from "./SchoolTypeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolTypeSwitch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SchoolTypeSwitch.vue?vue&type=style&index=0&id=cdcbb71e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcbb71e",
  null
  
)

export default component.exports